export const namespace = 'userDashboard'
